import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'
import AppButtons from '../../components/AppButtons/AppButtons'
import DefaultLayout from '../../components/DefaultLayout'
import Header from '../../components/Header/Header'
import { setSessionItem } from '../../storeManager'
import useLocale from 'js/hooks/useLocale'
import Spinner from 'js/components/Spinner/Spinner'

export default function FallbackPage() {
  const [isLoading, setIsLoading] = useState(true)
  const { pathname, search } = useLocation()
  const { language } = useLocale()

  useEffect(() => setSessionItem('bannerShown', true), [])

  useEffect(() => {
    if (pathname?.startsWith('/deep/settings')) {
      window.location.assign(`https://help.lifesum.com/${language}`)
    } else {
      setIsLoading(false)
    }
  }, [pathname, search, language])

  return (
    <DefaultLayout>
      {isLoading ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner width="50" color="green" />
        </div>
      ) : (
        <>
          <Header inverted={false} fixedPosition />
          <div className="o-width-limiter flex h-screen">
            <div className="m-auto max-w-768 py-96 text-center">
              <div
                className="relative mx-auto mb-24 pb-20"
                style={{ width: 110 }}
              >
                <img
                  src={require('media/app-icon.png')}
                  alt="Lifesum app icon"
                  className="w-full rounded-24"
                />
                <div
                  className="absolute bottom-0 left-0 right-0"
                  style={{
                    backgroundImage:
                      'radial-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))',
                    borderRadius: '50%',
                    height: 3,
                  }}
                />
              </div>
              <h1 className="type-med-fat mb-12 leading-default">
                <FormattedMessage
                  id="universal_link_fallback_heading"
                  defaultMessage="Seems like you don’t have Lifesum installed."
                />
              </h1>
              <p className="mb-24 xl:mb-40">
                <FormattedMessage
                  id="universal_link_fallback_text"
                  defaultMessage="Please go to the App Store or Google Play to download the app."
                />
              </p>
              <AppButtons />
            </div>
          </div>
        </>
      )}
    </DefaultLayout>
  )
}
